module.exports = __webpack_public_path__ + "/images/Sharepoint_File.png";